// extracted by mini-css-extract-plugin
export default {"Header_block_1":"MinorSliderHeader_Header_block_1__D2DzI"};